export const statistics = [
    {
        id: 1,
        title: "Dünya üzrə İllik şərab istehsalı",
        subtitle: "260 milyon hektolitr",
        icon: "fas fa-wine-bottle"
    },
    {
        id: 2,
        title: "Dünya üzrə İllik toplam istehlak",
        subtitle: "235 milyon hektolitr",
        icon: "fas fa-sync"
    },
    {
        id: 3,
        title: "Dünya üzrə İllik toplam gəlir",
        subtitle: "340 milyard dollar",
        icon: "fas fa-dollar-sign"
    },
    {
        id: 4,
        title: "Dünya üzrə şərab növünün sayı",
        subtitle: "10.000 növ",
        icon: "fas fa-th-list"
    },
];